export default "__VITE_ASSET__YURpT6jN__"